var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import ApiRequests from "../../../classes/http/ApiRequests";
import HttpRequests from "../../../classes/http/HttpRequests";
import Grid from '../../UI/Grid/Grid';
var AdjustmentLevelsList = /** @class */ (function (_super) {
    __extends(AdjustmentLevelsList, _super);
    function AdjustmentLevelsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.gridHeaders = [
            { name: 'От количество', key: 'from_quantity', filter: false, sort: false },
            { name: 'До количество', key: 'to_quantity', filter: false, sort: false },
            { name: 'Процентна отстъпка', key: 'percent_adjustment', filter: false, sort: false },
        ];
        _this.deleteAdjustmentLevel = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0437\u0430\u043F\u0438\u0441\u0430?");
            if (ask) {
                _this.props.deleteItem(selectedId);
            }
        };
        _this.editAction = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            if (selectedId) {
                _this.props.editItem(selectedId);
            }
        };
        return _this;
    }
    AdjustmentLevelsList.prototype.render = function () {
        var gridData = this.props.gridData;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: true, total: 50, rows: 10, editAction: this.editAction, deleteAction: this.deleteAdjustmentLevel }));
    };
    return AdjustmentLevelsList;
}(React.Component));
// @ts-ignore
export default withRouter(AdjustmentLevelsList);



//////////////////
// WEBPACK FOOTER
// ./src/components/AdjustmentLevels/AdjustmentLevelsList/VolumePromotionLevelsList.tsx
// module id = 517
// module chunks = 0